
import { Link } from "react-router-dom";
import { BookOpen, HelpCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

const HomeFooter = () => {
  return (
    <div className="text-center py-12 space-y-8 border-t border-gray-100">
      <div className="flex items-center justify-center gap-2">
        <Link 
          to="/how-it-works" 
          className="text-gray-600 hover:text-primary transition-colors inline-flex items-center gap-2"
        >
          <HelpCircle className="w-5 h-5" />
          <span>How It Works</span>
        </Link>
      </div>
      <div>
        <p className="text-lg text-gray-600 mb-6">Looking for inspiration?</p>
        <Link to="/recipes">
          <Button 
            variant="outline" 
            size="lg" 
            className="gap-3 h-14 px-8 text-lg hover:bg-primary hover:text-white transition-all duration-300 hover:scale-105 shadow-sm border-2 group"
          >
            <BookOpen className="w-6 h-6 group-hover:text-white transition-colors" />
            Browse Recipe Library
          </Button>
        </Link>
        <p className="text-sm text-gray-500 mt-4">
          Discover recipes from your favorite creators
        </p>
      </div>
    </div>
  );
};

export default HomeFooter;
